import { Injectable } from '@angular/core';


export class AppService {

	public init() {
		this.checkEnv();
	}

	private checkEnv() {
		if (process.env.ENV === 'production') {
			return;
		}

		document.getElementById('hj-fav-icon').setAttribute('href', 'assets/icons/favicon-dev.ico');
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/services/app.service.ts